import type { RouteObject } from 'react-router-dom'
import { Navigate } from 'react-router-dom'

import { ProtectedRoute } from '@/router/ProtectedRoute'

export const userRoutes: RouteObject[] = [
  {
    path: 'users',
    element: (
      <ProtectedRoute
        requiredRoles={['Administrador']}
        unauthorizedComponent={<Navigate to="/admin/catalogs" replace />}
      />
    ),
    children: [
      {
        index: true,
        lazy: async () => {
          const module = await import('@/features/admin/user/pages/UserListPage')
          return {
            element: <module.UserListPage />
          }
        }
      }
    ]
  }
  // {
  //   path: 'sessions',
  //   lazy: async () => {
  //     const module = await import('@/features/admin/user/pages/SessionListPage')
  //     return {
  //       element: <module.SessionListPage />
  //     }
  //   }
  // }
]
